module.exports = __webpack_public_path__ + "static/img/card-banner1.4a3d5e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/card-banner1.png
// module id = o1Ka
// module chunks = 1